import axios from "@/axios";

export const namespaced = true

export const state = {
    logisticsUserId: 0,
    financeUserId: 0,
    canUserEditOrder: false,
    orderUserTypes: []
}

export const getters = {
    logisticsUserId: (state) => state.logisticsUserId,
    financeUserId: (state) => state.financeUserId,
    canUserEditOrder: (state) => state.canUserEditOrder,
    orderUserTypes: (state) => state.orderUserTypes
}

export const mutations = {
    SET_LOGISTICS_USER(state, response) {
        state.logisticsUserId = response.data.userId;
    },
    SET_FINANCE_USER(state, response) {
        if (!response.data.userId) {
            state.financeUserId = 0;
        } else {
            state.financeUserId = response.data.userId;
        }
    },
    SET_USER_EDITIBILITY(state, response) {
        state.canUserEditOrder = response.data;
    },
    SET_ORDER_USER_TYPES(state, response) {
        state.orderUserTypes = response.data;
    },
    CLEAR_DATA(state) {
        state.logisticsUserId = null;
        state.financeUserId = null;
    }
}

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    async getOrderUserTypes({commit}) {
        let ret = await axios.get("/api/orderusers/types", {config: {showToast: false}});
        commit('SET_ORDER_USER_TYPES', ret);
    },
    async getOrderLogisticsUser({ commit }, orderId) {
        commit('SET_LOGISTICS_USER', await axios.get(`/api/orderusers/Logistics/${orderId}`))
    },
    async getOrderFinanceUser({ commit }, orderId) {
        commit('SET_FINANCE_USER', await axios.get(`/api/orderusers/Finance/${orderId}`))
    },
    async getUserEditibility({ commit }, orderId) {
        commit('SET_USER_EDITIBILITY', await axios.get(`/api/orders/usercanedit/${orderId}`))
    },
    // lets re-visit when we have the time
    async onLogisticsChange({ commit }, data) {
        try {
            let response = await axios.get(`/api/orderusers/Logistics/${data.orderId}`)
            let id = 0;

            if (response.data.orderUserId) {
                id = response.data.orderUserId;
            }

            let responsePost = await axios.post(`/api/orderusers/`, {
                orderUserId: id, orderId: data.orderId, userTypeId: 2, UserId: data.value
            },{ config: { showToast: true  } });

            return responsePost;
        }
        catch (e) {
            throw e;
        }
    },
    async onFinanceChange({ commit }, data) {
        try {
            let response = await axios.get(`/api/orderusers/Finance/${data.orderId}`)
            let id = 0;

            if (response.data.orderUserId) {
                id = response.data.orderUserId;
            }

            let responsePost = await axios.post(`/api/orderusers/`, {
                orderUserId: id, orderId: data.orderId, userTypeId: 3, UserId: data.value
            }, { config: { showToast: true } });

            return responsePost;
        }
        catch (e) {
            throw e;
        }
    }

}


